module.exports = (__parcel__import__("aYB7Q")).then(() => parcelRequire('kKorg'));